module.exports = __webpack_public_path__ + "img/maison-8.fc39d1de.png";